import { render, staticRenderFns } from "./service-charge.vue?vue&type=template&id=4d82f5e3&"
import script from "./service-charge.vue?vue&type=script&lang=js&"
export * from "./service-charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports